import { Dropdown, Menu, Spin } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
// import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getApi, getApiCSV, postApi } from 'redux/apis';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { ExportDataInterface } from './types';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';

const TIMEZONE = process.env.REACT_APP_TIMEZONE || 'America/New_York';

// For export data
const ExportData = (props: ExportDataInterface) => {
	const navigate = useNavigate();
	const { params, moduleName } = props;

	const payrollMethod = useSelector(
		(state: any) => state?.companies?.configurations?.payrollMethod
	);

	const [selectedOption, setSelectedOption] = useState('');

	const [isLoading, setIsLoading] = useState(false);

	const handleSelect = (value: string) => {
		setSelectedOption(value);
	};

	const handleEmployeeCostCsv = async () => {
		setIsLoading(true);
		try {
			const isPercentage = payrollMethod === 'Hours' ? false : true;
			const response: any = await getApi('/employee-cost/export', {
				companyId: localStorage.getItem('companyId'),
				includeInactive: params.includeInactive,
				search: params?.search,
				isPercentage,
				payPeriodId: params.payPeriodId,
			});
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const fileName = moment
				.tz(new Date(), TIMEZONE)
				.format('MMDDYYYYhhmmss');
			link.setAttribute('download', `Employee Cost_${fileName}.csv`);
			document.body.appendChild(link);
			link.click();
			link.remove();
		} catch (err: any) {
			if (err?.response?.data?.error?.status == 401) {
				navigate('/login');
				window.location.reload();
			}
			toastText('Error in downloading', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const base64ToBlob = (base64: string, mime: string) => {
		const byteCharacters = atob(base64);
		const arrayBuffer = new ArrayBuffer(byteCharacters.length);
		const uint8Array = new Uint8Array(arrayBuffer);
		for (let i = 0; i < byteCharacters.length; i++) {
			uint8Array[i] = byteCharacters.charCodeAt(i);
		}
		return new Blob([uint8Array], { type: mime });
	};

	const handleExport = async () => {
		if (selectedOption == 'csv') {
			if (moduleName === 'timeActivity') {
				try {
					const query: any = {
						search: params?.search,
						employeeId: params?.filter?.employeeId,
						classId: params?.filter?.classId,
						customerId: params?.filter?.customerId,
						payPeriodId: params?.payPeriodId,
						payPeriodData: params?.payPeriodData,
						sort:
							params?.sortName === 'customer'
								? 'customerName'
								: params?.sortName === 'class'
									? 'className'
									: params?.sortName,
						type: params?.sortValue === 'ascend' ? 'asc' : 'desc',
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						delete query.classId;
					}

					// const formatedStartDate = moment(query?.startDate).format(
					// 	'MM/DD/YYYY'
					// );
					// const formatedEndDate = moment(query?.endDate).format('MM/DD/YYYY');

					setIsLoading(true);
					const response: any = await getApiCSV('/time-activities/export', {
						companyId: localStorage.getItem('companyId'),
						...query,
					});
					const url = window.URL.createObjectURL(
						new Blob([response.data], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						})
					);

					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', `Time Log Report_${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading', 'error');
					console.error(err);
					setIsLoading(false);
				}
			} else if (moduleName === 'costAllocations') {
				try {
					const query: any = {
						payPeriodId: params.payPeriodId,
						companyId: localStorage.getItem('companyId'),
						search: params.searchValue,
						sort: params.sort,
						type: params.type,
						...params.filterValue,
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.classId;
					}

					setIsLoading(true);
					const response: any = await getApi(
						'/cost-allocation/export-csv',
						query
					);
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					link.setAttribute('download', `CostAllocation_${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading csv', 'error');
					setIsLoading(false);
				}
			} else if (moduleName === 'timeSummaryReport') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						payPeriodId: params?.payPeriodId,
						search: params.searchValue,
						...params.filterValue,
					};

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					const response: any = await getApi(
						'/reports/time-activity-summary-csv',
						query
					);
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					link.setAttribute('download', `TimeActivitySummary${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading csv', 'error');
					setIsLoading(false);
				}
			} else if (moduleName === 'payrollSummaryReport') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						payPeriodId: params?.payPeriodId,
						search: params.searchValue,
						...params.filterValue,
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						delete query.classId;
					}

					const response: any = await getApi(
						'/reports/payroll-expense-summary-csv',
						query
					);
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					link.setAttribute('download', `PayrollSummary${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err) {
					toastText('Error in downloading csv', 'error');
					setIsLoading(false);
				}
			} else if (moduleName === 'expenseAllocation') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						expenseGroupId: params?.expenseGroupId,
						fromDate: params?.fromDate,
						toDate: params?.toDate,
						tempAccounts: params?.tempAccounts,
						tempConfigAllocations: params?.tempConfigAllocations,
						tempFlag: params?.tempFlag,
						isSingleAccountAllocation: params?.isSingleAccountAllocation,
						configAccount: params?.configAccount,
					};
					const response: any = await getApi(
						'/expense-journal/export-csv',
						query
					);
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					link.setAttribute('download', `ExpenseAllocation_${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading csv', 'error');
					setIsLoading(false);
				}
			} else if (moduleName === 'oneOffExpenseAllocation') {
				try {
					setIsLoading(true);
					const query = {
						companyId: localStorage.getItem('companyId'),
						fromDate: params?.fromDate,
						toDate: params?.toDate,
						oneOffConfigurations: params?.oneOffConfigurations,
					};
					const response: any = await postApi(
						'/expense-journal/one-off-export-csv',
						query
					);
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					link.setAttribute('download', `OneOffExpenseAllocation_${fileName}.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();

					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading csv', 'error');
					setIsLoading(false);
				}
			}
		} else if (selectedOption == 'pdf') {
			if (moduleName === 'timeActivity') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						search: params?.search ?? '',
						classId: params?.filter?.classId ?? '',
						customerId: params?.filter?.customerId ?? '',
						employeeId: params?.filter?.employeeId ?? '',
						payPeriodId: params?.payPeriodId ?? '',
						sort:
							params?.sortName === 'customer'
								? 'customerName'
								: params?.sortName === 'class'
									? 'className'
									: params?.sortName ?? '',
						type: params?.sortValue === 'ascend' ? 'asc' : params?.sortValue === 'descend' ? 'desc' : '',
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						delete query.classId;
					}

					const response = await postApi('/time-activities/exportpdf', query);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `Time Log Report_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err) {
					setIsLoading(false);
					toastText('Error in downloading pdf', 'error');
				}
			} else if (moduleName === 'costAllocations') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						payPeriodId: params?.payPeriodId,
						search: params.searchValue,
						sort: params.sort,
						type: params.type,
						...params.filterValue,
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						// Always delete if not an array or empty array (handles undefined, null, string, empty array, etc.)
						delete query.classId;
					}

					const response = await getApi('/cost-allocation/export-pdf', query);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `CostAllocation_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err) {
					setIsLoading(false);
				}
			} else if (moduleName === 'timeSummaryReport') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						payPeriodId: params?.payPeriodId,
						search: params.searchValue,
						...params.filterValue,
					};

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					const response = await getApi(
						'/reports/time-activity-summary-pdf',
						query
					);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `TimeSummaryReport_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err) {
					setIsLoading(false);
				}
			} else if (moduleName === 'payrollSummaryReport') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						payPeriodId: params?.payPeriodId,
						search: params.searchValue,
						...params.filterValue,
					};

					// Handle employeeId as array - convert to comma-separated string for API
					if (Array.isArray(query.employeeId) && query.employeeId.length > 0) {
						query.employeeId = query.employeeId.join(',');
					} else {
						delete query.employeeId;
					}

					// Handle customerId as array - convert to comma-separated string for API
					if (Array.isArray(query.customerId) && query.customerId.length > 0) {
						query.customerId = query.customerId.join(',');
					} else {
						delete query.customerId;
					}

					// Handle classId as array - convert to comma-separated string for API
					if (Array.isArray(query.classId) && query.classId.length > 0) {
						query.classId = query.classId.join(',');
					} else {
						delete query.classId;
					}

					const response = await getApi(
						'/reports/payroll-expense-summary-pdf',
						query
					);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					// const fileName = moment(new Date()).format('MMDDYYYYhhmmss');
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `PayrollSummaryReport_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err) {
					console.log('EEEE:', err);
					setIsLoading(false);
				}
			} else if (moduleName === 'expenseAllocation') {
				try {
					setIsLoading(true);
					const query: any = {
						companyId: localStorage.getItem('companyId'),
						expenseGroupId: params?.expenseGroupId,
						fromDate: params?.fromDate,
						toDate: params?.toDate,
						tempAccounts: params?.tempAccounts,
						tempConfigAllocations: params?.tempConfigAllocations,
						tempFlag: params?.tempFlag,
						isSingleAccountAllocation: params?.isSingleAccountAllocation,
						configAccount: params?.configAccount,
					};

					const response = await getApi('/expense-journal/export-pdf', query);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `ExpenseAllocation_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading pdf', 'error');
					setIsLoading(false);
				}
			} else if (moduleName === 'oneOffExpenseAllocation') {
				try {
					setIsLoading(true);
					const query = {
						companyId: localStorage.getItem('companyId'),
						fromDate: params?.fromDate,
						toDate: params?.toDate,
						oneOffConfigurations: params?.oneOffConfigurations,
					};

					const response = await postApi('/expense-journal/one-off-export-pdf', query);
					const blob = base64ToBlob(response.data.data, 'application/pdf');
					const blobUrl = URL.createObjectURL(blob);

					const a = document.createElement('a');
					a.href = blobUrl;
					const fileName = moment
						.tz(new Date(), TIMEZONE)
						.format('MMDDYYYYhhmmss');
					a.download = `OneOffExpenseAllocation_${fileName}.pdf`;
					a.style.display = 'none';

					document.body.appendChild(a);
					a.click();
					URL.revokeObjectURL(blobUrl);
					setIsLoading(false);
				} catch (err: any) {
					if (err?.response?.data?.error?.status == 401) {
						navigate('/login');
						window.location.reload();
					}
					toastText('Error in downloading pdf', 'error');
					setIsLoading(false);
				}
			}
		}
	};

	useEffect(() => {
		handleExport().then(() => {
			handleSelect('');
		});
	}, [selectedOption]);

	const exportMenu = (
		<Menu onClick={({ key }) => handleSelect(key)}>
			<Menu.Item key="pdf" style={{ fontSize: '12px' }}>
				PDF
			</Menu.Item>
			<Menu.Item key="csv" style={{ fontSize: '12px' }}>
				.CSV
			</Menu.Item>
		</Menu>
	);

	const buttonContent = (
		<>
			Export
			<span className={styles['export-data__wrapper-svg']}>
				{isLoading ? (
					<Spin size="small" className={styles['export-spinner']} />
				) : (
					<DownloadOutlined />
				)}
			</span>
		</>
	);

	return (
		<div className={` ${styles['export-data']}`}>
			<div className={styles['export-data__wrapper']}>
				{moduleName === 'employeeCost' ? (
					<button
						className={styles['export-data__button']}
						onClick={handleEmployeeCostCsv}
						disabled={isLoading}
					>
						{buttonContent}
					</button>
				) : (
					<Dropdown
						overlay={exportMenu}
						trigger={['click']}
						placement="bottomRight"
					>
						<button className={styles['export-data__button']}>
							{buttonContent}
						</button>
					</Dropdown>
				)}
			</div>
		</div>
	);
};

export default ExportData;
